import React from 'react';
import PropTypes from 'prop-types';
import humps from 'humps';
import _ from 'underscore';
import http from '../../../shared/http';
import BeaconAlert from './BeaconAlert';

const hasError = validation =>
  validation &&
  (validation.urlValid === false || validation.gdprCompliant === false);

const useBeaconValidation = (url, applyGdprValidations) => {
  const [validationState, setValidationState] = React.useState({});

  // TODO handle initial value for this field
  const [vendorId, setVendorId] = React.useState(undefined);

  const triggerValidationRequest = React.useCallback(
    _.throttle(
      async payload => {
        const resp = await http.post('/beacons/validate', payload);

        const { urlValid, gdprCompliant, vendor } = humps.camelizeKeys(
          resp.data
        );
        setValidationState({ urlValid, gdprCompliant });

        if (vendor) {
          setVendorId(vendor.vendorId);
        }
      },
      1000,
      true
    ),
    []
  );

  // PSA: this effect will run on the inital render
  React.useEffect(
    function validateUrl() {
      if (url === '') {
        setValidationState({ urlValid: true, gdprCompliant: true });
        setVendorId(null);
        return;
      }

      triggerValidationRequest({
        url,
        apply_gdpr_validations: applyGdprValidations
      });
    },
    // TODO: once angular beacon validation is done, trigger re-validation here
    // when Running in EU field is changed by adding `applyGdprValidation` to
    // the deps array
    [url]
  );

  return {
    triggerValidationRequest,
    validationState,
    vendorId
  };
};

export const BeaconInput = ({
  children,
  labelContent,
  nameAttr,
  applyGdprValidations,
  button,
  onInputChange,
  onVendorChange,
  value
}) => {
  const { validationState, vendorId } = useBeaconValidation(
    value,
    applyGdprValidations
  );

  React.useEffect(
    function syncVendorId() {
      // TODO: do better
      if (vendorId !== undefined) {
        onVendorChange(vendorId);
      }
    },
    [vendorId]
  );

  return (
    <div
      className={`input-with-label-inside mb2 form-group ${
        hasError(validationState) ? 'has-error' : ''
      }`}
    >
      <div className="input-group">
        <label htmlFor={nameAttr}>{labelContent}</label>
        <input
          id={nameAttr}
          className="form-control"
          name={nameAttr}
          onChange={onInputChange}
          value={value}
          placeholder="https://"
        />
        <span className="input-group-btn">{button}</span>
      </div>
      {children ? children : null}
      <BeaconAlert {...validationState} />
    </div>
  );
};

BeaconInput.propTypes = {
  applyGdprValidations: PropTypes.bool.isRequired,
  children: PropTypes.node,
  labelContent: PropTypes.node.isRequired,
  nameAttr: PropTypes.string.isRequired,
  button: PropTypes.node.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onVendorChange: PropTypes.func.isRequired,
  value: PropTypes.string
};
BeaconInput.defaultProps = {
  children: null,
  value: ''
};
